import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/vercel/path0/layouts/admin.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  none: defineAsyncComponent(() => import("/vercel/path0/layouts/none.vue").then(m => m.default || m))
}